import { Pipe, PipeTransform } from '@angular/core';
import { snakeCase } from 'lodash';
/*
* Returns the snakeCase of a string
*/
@Pipe({name: 'snakecase'})
export class SnakecasePipe implements PipeTransform {
  transform(value: string): string {
    return snakeCase(value);
  }
}